export const VALIDATION_ERROR_CODE = 'VALIDATION_ERROR';
export const ALL_ENTRY_VALIDATION_ERROR_CODE = 'ALL_ENTRY_VALIDATION_ERROR';
export const VALIDATION_REQUEST_CODE = '422';
export const VALIDATION_QUERY_ALREADY_IN_USE_ERROR_CODE =
  'QUERY_ALREADY_IN_USE';
export const CUSTOM_VALIDATION_EXPRESSION_FAILED =
  'CUSTOM_VALIDATION_EXPRESSION_FAILED';
